<template>
  <div class="sv-wrap">
    <div class="sv-scroll-x">
      <table class="sv-table">
        <thead>
          <tr>
            <th class="sv-th-staff">护工</th>
            <th
              v-for="day in weekDays"
              :key="day.date"
              class="sv-th-day"
              :class="{ 'sv-today-col': day.date === todayStr }">
              <span class="sv-week">{{ day.weekLabel }}</span>
              <span class="sv-date" :class="{ 'sv-today': day.date === todayStr }">{{ day.dayLabel }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!activeStaff.length">
            <td :colspan="weekDays.length + 1" class="sv-empty">
              <i class="el-icon-user" style="font-size:32px;color:#CBD5E1;display:block;margin-bottom:8px"></i>
              {{ rangeLabel }}暂无排班记录
            </td>
          </tr>
          <tr
            v-for="staff in activeStaff"
            :key="staff.staffId"
            class="sv-row"
            @click="openStaffDetail(staff)">
            <td class="sv-td-staff">
              <div class="sv-staff-info">
                <span class="sv-avatar" :style="{ background: getAvatarColor(staff.staffId) }">
                  {{ staff.staffName ? staff.staffName.charAt(0) : '?' }}
                </span>
                <div class="sv-staff-text">
                  <div class="sv-staff-name">{{ staff.staffName }}</div>
                  <div class="sv-staff-sub">{{ getStaffGroupName(staff.staffId) }}</div>
                </div>
              </div>
            </td>
            <td
              v-for="day in weekDays"
              :key="day.date"
              class="sv-td-cell"
              :class="{ 'sv-cell-weekend': isWeekend(day.date), 'sv-today-cell': day.date === todayStr }">
              <div class="sv-cell-inner">
                <div
                  v-for="s in getStaffDaySchedules(staff.staffId, day.date)"
                  :key="s.id || (s.shiftId + '-' + s.date)"
                  class="sv-shift-chip"
                  :style="{ borderLeft: '3px solid ' + (getShiftColor(s.shiftId)), background: hexToLight(getShiftColor(s.shiftId)) }">
                  <span class="sv-chip-dot" :style="{ background: getShiftColor(s.shiftId) }"></span>
                  <span class="sv-chip-name">{{ s.shiftName || getShiftName(s.shiftId) }}</span>
                  <span class="sv-chip-rooms" v-if="s.roomList && s.roomList.length">
                    <i class="el-icon-house" style="font-size:10px;opacity:0.6;flex-shrink:0;margin-right:2px"></i>
                    <span v-if="s.roomList.length <= 3">{{ s.roomList.map(r => r.roomNo).join(' ') }}</span>
                    <span v-else>{{ s.roomList.slice(0, 3).map(r => r.roomNo).join(' ') }}等{{ s.roomList.length }}间</span>
                  </span>
                </div>
                <div v-if="!getStaffDaySchedules(staff.staffId, day.date).length" class="sv-no-shift">
                  <span>—</span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 个人排班详情弹窗 -->
    <el-dialog
      :visible.sync="detailVisible"
      :show-close="false"
      :append-to-body="true"
      width="560px"
      custom-class="sv-detail-dialog">
      <div class="sd-modal" v-if="detailStaff">
        <div class="sd-header">
          <div class="sd-header-left">
            <span class="sd-avatar" :style="{ background: getAvatarColor(detailStaff.staffId) }">
              {{ detailStaff.staffName ? detailStaff.staffName.charAt(0) : '?' }}
            </span>
            <div>
              <div class="sd-name">{{ detailStaff.staffName }}</div>
              <div class="sd-sub">{{ rangeLabel }}排班详情 · 共 {{ detailSchedules.length }} 条</div>
            </div>
          </div>
          <div class="sd-close" @click="detailVisible = false">
            <i class="el-icon-close" style="color:#94A3B8;font-size:16px"></i>
          </div>
        </div>
        <div class="sd-body">
          <div v-if="!detailSchedules.length" class="sd-empty">
            <i class="el-icon-calendar" style="font-size:32px;color:#CBD5E1;display:block;margin-bottom:8px"></i>
            该时段暂无排班记录
          </div>
          <div v-else class="sd-list">
            <div
              v-for="s in detailSchedules"
              :key="s.id || (s.shiftId + '-' + s.date)"
              class="sd-item">
              <div class="sd-item-date">
                <span class="sd-week-label">{{ getWeekLabelLocal(s.date) }}</span>
                <span class="sd-date-text">{{ s.date ? s.date.substring(0, 10) : '' }}</span>
              </div>
              <div class="sd-item-shift"
                :style="{ background: hexToLight(getShiftColor(s.shiftId)), borderLeft: '3px solid ' + getShiftColor(s.shiftId) }">
                <span class="sd-shift-dot" :style="{ background: getShiftColor(s.shiftId) }"></span>
                <div class="sd-shift-info">
                  <div class="sd-shift-name">{{ s.shiftName || getShiftName(s.shiftId) }}</div>
                  <div class="sd-shift-time">{{ getShiftTime(s.shiftId) }}</div>
                </div>
                <div class="sd-rooms" v-if="s.roomList && s.roomList.length">
                  <i class="el-icon-house" style="font-size:11px;color:#64748B;flex-shrink:0;margin-right:4px"></i>
                  <span class="sd-room-tags">
                    <span v-for="r in s.roomList" :key="r.roomId" class="sd-room-tag">{{ r.roomNo }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sd-footer">
          <el-button size="small" @click="$emit('add', { staffId: detailStaff.staffId })">
            <i class="el-icon-plus"></i> 新增排班
          </el-button>
          <el-button type="primary" size="small" @click="detailVisible = false">关闭</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { hexToLight, getAvatarColor } from '../scheduleUtils'

export default {
  name: 'StaffView',
  props: {
    scheduleList: { type: Array, default: () => [] },
    staffList: { type: Array, default: () => [] },
    shiftList: { type: Array, default: () => [] },
    weekDays: { type: Array, default: () => [] },
    todayStr: { type: String, default: '' },
    rangeLabel: { type: String, default: '本周' }
  },
  data() {
    return {
      detailVisible: false,
      detailStaff: null
    }
  },
  computed: {
    // 从 scheduleList 中动态提取有排班的护工列表
    activeStaff() {
      const map = {}
      for (const s of this.scheduleList) {
        const key = String(s.staffId)
        if (!map[key]) {
          map[key] = { staffId: s.staffId, staffName: s.staffName }
        }
      }
      return Object.values(map)
    },
    // 当前详情护工的所有排班（按日期排序）
    detailSchedules() {
      if (!this.detailStaff) return []
      return this.scheduleList
        .filter(s => String(s.staffId) === String(this.detailStaff.staffId))
        .sort((a, b) => {
          const da = a.date ? a.date.substring(0, 10) : ''
          const db = b.date ? b.date.substring(0, 10) : ''
          return da < db ? -1 : da > db ? 1 : 0
        })
    }
  },
  methods: {
    hexToLight,
    getAvatarColor,
    isWeekend(date) {
      const d = new Date(date).getDay()
      return d === 0 || d === 6
    },
    getShiftColor(shiftId) {
      const s = this.shiftList.find(x => String(x.id) === String(shiftId))
      return s ? (s.color || '#2563EB') : '#2563EB'
    },
    getShiftName(shiftId) {
      const s = this.shiftList.find(x => String(x.id) === String(shiftId))
      return s ? s.name : ''
    },
    getShiftTime(shiftId) {
      const s = this.shiftList.find(x => String(x.id) === String(shiftId))
      return s ? (s.time || '') : ''
    },
    getStaffGroupName(staffId) {
      const s = this.staffList.find(x => String(x.userId) === String(staffId))
      return s ? (s.nursingGroupName || '') : ''
    },
    getStaffDaySchedules(staffId, date) {
      return this.scheduleList.filter(s =>
        String(s.staffId) === String(staffId) &&
        s.date && s.date.substring(0, 10) === date
      )
    },
    getWeekLabelLocal(date) {
      if (!date) return ''
      const labels = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
      return labels[new Date(date.substring(0, 10)).getDay()]
    },
    openStaffDetail(staff) {
      this.detailStaff = staff
      this.detailVisible = true
    }
  }
}
</script>

<style scoped>
.sv-wrap { flex: 1; min-height: 0; display: flex; flex-direction: column; overflow: hidden; }
.sv-scroll-x { flex: 1; min-height: 0; overflow: auto; }
.sv-table { border-collapse: collapse; width: 100%; min-width: max-content; }
.sv-th-staff {
  width: 160px; min-width: 160px; padding: 10px 14px; text-align: left;
  font-size: 13px; font-weight: 600; color: #64748B;
  background: #F8FAFC; border-bottom: 2px solid #E2E8F0; border-right: 1px solid #E2E8F0;
  position: sticky; left: 0; z-index: 3;
}
.sv-th-day {
  min-width: 140px; padding: 10px 14px; text-align: center;
  background: #F8FAFC; border-bottom: 2px solid #E2E8F0; border-right: 1px solid #E2E8F0;
}
.sv-th-day:last-child { border-right: none; }
.sv-today-col { background: #EFF6FF; }
.sv-week { display: block; font-size: 11px; color: #94A3B8; }
.sv-date { display: block; font-size: 13px; font-weight: 600; color: #1E293B; }
.sv-today { color: #2563EB; }
.sv-row { cursor: pointer; }
.sv-row:hover .sv-td-staff { background: #F8FAFC; }
.sv-row td { border-bottom: 1px solid #F1F5F9; }
.sv-td-staff {
  width: 160px; min-width: 160px; padding: 10px 14px;
  background: #fff; border-right: 1px solid #E2E8F0; vertical-align: middle;
  position: sticky; left: 0; z-index: 1;
}
.sv-staff-info { display: flex; align-items: center; }
.sv-avatar {
  width: 32px; height: 32px; border-radius: 50%; flex-shrink: 0;
  color: #fff; font-size: 12px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
  margin-right: 8px;
}
.sv-staff-text { min-width: 0; }
.sv-staff-name { font-size: 13px; font-weight: 600; color: #1E293B; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.sv-staff-sub { font-size: 11px; color: #94A3B8; margin-top: 1px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.sv-td-cell {
  min-width: 140px; padding: 6px 8px; vertical-align: top;
  border-right: 1px solid #F1F5F9; height: 1px;
}
.sv-td-cell:last-child { border-right: none; }
.sv-cell-weekend { background: #FAFAFA; }
.sv-today-cell { background: #F0F7FF; }
.sv-cell-inner { display: flex; flex-direction: column; min-height: 56px; height: 100%; }
.sv-cell-inner > * { margin-bottom: 3px; }
.sv-shift-chip {
  display: flex; align-items: center;
  padding: 5px 8px; border-radius: 6px; overflow: hidden;
}
.sv-chip-dot {
  width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; margin-right: 5px;
}
.sv-chip-name { font-size: 12px; font-weight: 600; color: #1E293B; flex-shrink: 0; margin-right: 4px; }
.sv-chip-rooms {
  font-size: 11px; color: #64748B; flex: 1; min-width: 0;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  display: flex; align-items: center;
}
.sv-no-shift { display: flex; align-items: center; justify-content: center; flex: 1; color: #CBD5E1; font-size: 14px; }
.sv-empty { padding: 40px; text-align: center; color: #94A3B8; font-size: 13px; }
/* 详情弹窗 */
.sd-modal { display: flex; flex-direction: column; max-height: 80vh; }
.sd-header {
  display: flex; justify-content: space-between; align-items: center;
  padding: 18px 20px 14px; border-bottom: 1px solid #E2E8F0;
}
.sd-header-left { display: flex; align-items: center; }
.sd-avatar {
  width: 44px; height: 44px; border-radius: 50%; flex-shrink: 0;
  color: #fff; font-size: 16px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
  margin-right: 12px;
}
.sd-name { font-size: 16px; font-weight: 600; color: #1E293B; }
.sd-sub { font-size: 12px; color: #94A3B8; margin-top: 2px; }
.sd-close { width: 30px; height: 30px; border-radius: 6px; cursor: pointer; display: flex; align-items: center; justify-content: center; }
.sd-close:hover { background: #F1F5F9; }
.sd-body { flex: 1; overflow-y: auto; padding: 14px 20px; }
.sd-empty { text-align: center; padding: 30px 0; color: #94A3B8; }
.sd-list { display: flex; flex-direction: column; }
.sd-item { display: flex; align-items: flex-start; margin-bottom: 10px; }
.sd-item-date {
  width: 90px; flex-shrink: 0; padding-top: 8px;
  display: flex; flex-direction: column; align-items: flex-end; padding-right: 12px;
}
.sd-week-label { font-size: 11px; color: #94A3B8; }
.sd-date-text { font-size: 12px; font-weight: 600; color: #475569; margin-top: 2px; }
.sd-item-shift {
  flex: 1; display: flex; align-items: flex-start;
  padding: 8px 12px; border-radius: 8px; min-width: 0;
}
.sd-shift-dot {
  width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0;
  margin-right: 8px; margin-top: 4px;
}
.sd-shift-info { flex-shrink: 0; margin-right: 12px; }
.sd-shift-name { font-size: 13px; font-weight: 600; color: #1E293B; }
.sd-shift-time { font-size: 11px; color: #94A3B8; margin-top: 2px; }
.sd-rooms { display: flex; align-items: flex-start; flex: 1; min-width: 0; }
.sd-room-tags { display: flex; flex-wrap: wrap; }
.sd-room-tag {
  padding: 2px 6px; border-radius: 4px; background: #F1F5F9;
  color: #475569; font-size: 11px; margin-right: 4px; margin-bottom: 3px;
}
.sd-footer {
  display: flex; justify-content: flex-end;
  padding: 12px 20px; border-top: 1px solid #E2E8F0;
}
.sd-footer .el-button { margin-left: 8px; }
</style>

<style>
.sv-detail-dialog .el-dialog__header { display: none; }
.sv-detail-dialog .el-dialog__body { padding: 0; }
</style>
